<!-- 选题申请 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 35.59">
    <title>选题申请</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="26.99" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="26.99" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M19.21,9.37H10.43l-.1-7.08a5.83,5.83,0,0,0-5.22,4.1V18.91s-.62,6.36,6.05,6.36h19.4V17.4"
        />
        <path class="cls-3" d="M30.56,11.84V9.37H26.07" />
        <path
          class="cls-3"
          d="M25.52,18.4c.17,0,.26.24.15.39l-1.35,1.85-1.59,2.19a0,0,0,0,1-.07,0l-1.6-2.19-1.34-1.85a.24.24,0,0,1,.15-.39"
        />
        <path class="cls-3" d="M10.45,9.06v6.5A8,8,0,0,0,5.11,18.7" />
        <line class="cls-4" x1="19.37" y1="6.34" x2="25.58" y2="6.34" />
        <ellipse class="cls-5" cx="30.64" cy="14.46" rx="0.94" ry="0.89" />
        <path
          class="cls-6"
          d="M19.47,2.32v15a1.15,1.15,0,0,0,1.16,1.13H24.8A1.15,1.15,0,0,0,26,17.35v-15A1.14,1.14,0,0,0,24.8,1.2H20.63A1.14,1.14,0,0,0,19.47,2.32Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 35.59">
    <title>选题申请</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="26.99" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="26.99" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M19.21,9.37H10.43l-.1-7.08a5.83,5.83,0,0,0-5.22,4.1V18.91s-.62,6.36,6.05,6.36h19.4V17.41"
        />
        <path class="cls-3" d="M30.56,11.84V9.37H26.07" />
        <path
          class="cls-3"
          d="M25.52,18.4c.17,0,.26.24.15.39l-1.35,1.85-1.59,2.19a0,0,0,0,1-.07,0l-1.6-2.19-1.34-1.85a.24.24,0,0,1,.15-.39"
        />
        <path class="cls-3" d="M10.45,9.06v6.5a7.94,7.94,0,0,0-5.34,3.15" />
        <line class="cls-4" x1="19.43" y1="6.31" x2="25.58" y2="6.31" />
        <ellipse class="cls-5" cx="30.64" cy="14.46" rx="0.94" ry="0.89" />
        <path
          class="cls-3"
          d="M19.47,2.33v15a1.15,1.15,0,0,0,1.16,1.13H24.8A1.15,1.15,0,0,0,26,17.35v-15A1.15,1.15,0,0,0,24.8,1.2H20.63A1.15,1.15,0,0,0,19.47,2.33Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.33 33.4">
    <title>选题申请</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.67" cy="24.77" rx="17.67" ry="8.63" />
        <ellipse class="cls-2" cx="17.67" cy="24.77" rx="13.66" ry="6.82" />
        <path
          class="cls-3"
          d="M19.46,9.07H10.89l-.1-6.91a5.68,5.68,0,0,0-5.09,4V18.39s-.61,6.21,5.9,6.21H30.54V16.92"
        />
        <path class="cls-3" d="M30.54,11.48V9.07H26.16" />
        <path
          class="cls-4"
          d="M25.62,18.18a.22.22,0,0,1,.15.36l-1.32,1.68-1.56,2s0,0-.06,0l-1.56-2L20,18.54a.22.22,0,0,1,.14-.36"
        />
        <path class="cls-3" d="M10.91,8.77v6.35A7.74,7.74,0,0,0,5.7,18.19" />
        <line class="cls-5" x1="19.96" y1="6.06" x2="25.68" y2="6.06" />
        <ellipse class="cls-6" cx="30.59" cy="14.02" rx="1.05" ry="1.01" />
        <rect
          class="cls-3"
          x="19.72"
          y="1.1"
          width="6.34"
          height="17.42"
          rx="1.13"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3,
    .cls-4,
    .cls-6 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 2.44px;
    }
    .cls-4 {
      stroke-width: 2.17px;
    }
    .cls-5 {
      fill: #9a9b9b;
    }
    .cls-6 {
      stroke-width: 2.4px;
    }
  }
  //进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3,
    .cls-4 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 2.4px;
    }
    .cls-4 {
      stroke-width: 2.2px;
    }
    .cls-5 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3,
    .cls-4,
    .cls-5 {
      fill: none;
      stroke: #1ba586;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 2.2px;
    }
    .cls-4 {
      stroke-width: 2.13px;
    }
    .cls-5 {
      stroke-width: 1.92px;
    }
    .cls-6 {
      fill: #1ba586;
    }
  }
</style>
